function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useMemo } from 'react';
import { useMantineDefaultProps, Text, Box } from '@mantine/core';
import { upperFirst } from '@mantine/hooks';
import dayjs from 'dayjs';
import { getMonthDays } from '../../utils/get-month-days/get-month-days.js';
import { getWeekdaysNames } from '../../utils/get-weekdays-names/get-weekdays-names.js';
import { isSameDate } from '../../utils/is-same-date/is-same-date.js';
import { Day } from './Day/Day.js';
import { getDayProps } from './get-day-props/get-day-props.js';
import useStyles from './Month.styles.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

var no = function no() {
  return false;
};

var defaultProps = {
  disableOutsideEvents: false,
  hideWeekdays: false,
  __staticSelector: "Month",
  size: "sm",
  fullWidth: false,
  preventFocus: false,
  focusable: true,
  firstDayOfWeek: "monday",
  hideOutsideDates: false,
  weekendDays: [0, 6]
};
var Month = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Month", defaultProps, props),
      className = _a.className,
      month = _a.month,
      value = _a.value,
      onChange = _a.onChange,
      disableOutsideEvents = _a.disableOutsideEvents,
      locale = _a.locale,
      dayClassName = _a.dayClassName,
      dayStyle = _a.dayStyle,
      classNames = _a.classNames,
      styles = _a.styles,
      minDate = _a.minDate,
      maxDate = _a.maxDate,
      excludeDate = _a.excludeDate,
      onDayMouseEnter = _a.onDayMouseEnter,
      range = _a.range,
      hideWeekdays = _a.hideWeekdays,
      __staticSelector = _a.__staticSelector,
      size = _a.size,
      fullWidth = _a.fullWidth,
      preventFocus = _a.preventFocus,
      focusable = _a.focusable,
      firstDayOfWeek = _a.firstDayOfWeek,
      onDayKeyDown = _a.onDayKeyDown,
      daysRefs = _a.daysRefs,
      hideOutsideDates = _a.hideOutsideDates,
      _a$isDateInRange = _a.isDateInRange,
      isDateInRange = _a$isDateInRange === void 0 ? no : _a$isDateInRange,
      _a$isDateFirstInRange = _a.isDateFirstInRange,
      isDateFirstInRange = _a$isDateFirstInRange === void 0 ? no : _a$isDateFirstInRange,
      _a$isDateLastInRange = _a.isDateLastInRange,
      isDateLastInRange = _a$isDateLastInRange === void 0 ? no : _a$isDateLastInRange,
      renderDay = _a.renderDay,
      weekdayLabelFormat = _a.weekdayLabelFormat,
      weekendDays = _a.weekendDays,
      others = __objRest(_a, ["className", "month", "value", "onChange", "disableOutsideEvents", "locale", "dayClassName", "dayStyle", "classNames", "styles", "minDate", "maxDate", "excludeDate", "onDayMouseEnter", "range", "hideWeekdays", "__staticSelector", "size", "fullWidth", "preventFocus", "focusable", "firstDayOfWeek", "onDayKeyDown", "daysRefs", "hideOutsideDates", "isDateInRange", "isDateFirstInRange", "isDateLastInRange", "renderDay", "weekdayLabelFormat", "weekendDays"]);

  var _useStyles = useStyles({
    fullWidth: fullWidth
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var finalLocale = locale || theme.datesLocale;
  var days = getMonthDays(month, firstDayOfWeek);
  var weekdays = getWeekdaysNames(finalLocale, firstDayOfWeek, weekdayLabelFormat).map(function (weekday) {
    return /* @__PURE__ */React.createElement("th", {
      className: classes.weekdayCell,
      key: weekday
    }, /* @__PURE__ */React.createElement(Text, {
      size: size,
      className: classes.weekday
    }, weekday.length >= 2 ? upperFirst(weekday) : weekday));
  });
  var hasValue = Array.isArray(value) ? value.every(function (item) {
    return item instanceof Date;
  }) : value instanceof Date;
  var hasValueInMonthRange = value instanceof Date && dayjs(value).isAfter(dayjs(month).startOf("month")) && dayjs(value).isBefore(dayjs(month).endOf("month"));
  var firstDayOfMonth = useMemo(function () {
    var actualFirstDayDisabled = false;
    var firstDay;

    for (var i = 0; i < days.length; i += 1) {
      if (firstDay) {
        break;
      }

      var dates = days[i];

      for (var j = 0; j < dates.length; j += 1) {
        var date = dates[j];
        var dayProps = getDayProps({
          date: date,
          month: month,
          hasValue: hasValue,
          minDate: minDate,
          maxDate: maxDate,
          value: value,
          excludeDate: excludeDate,
          disableOutsideEvents: disableOutsideEvents,
          range: range,
          weekendDays: weekendDays
        });

        if (actualFirstDayDisabled && !dayProps.disabled) {
          firstDay = date;
          break;
        }

        var first = hideOutsideDates ? isSameDate(date, dayjs(month).startOf("month").toDate()) : j === 0 && i === 0;

        if (first && !dayProps.disabled) {
          firstDay = date;
          break;
        } else if (first && dayProps.disabled) {
          actualFirstDayDisabled = true;
        }
      }
    }

    return firstDay;
  }, []);
  var rows = days.map(function (row, rowIndex) {
    var cells = row.map(function (date, cellIndex) {
      var dayProps = getDayProps({
        date: date,
        month: month,
        hasValue: hasValue,
        minDate: minDate,
        maxDate: maxDate,
        value: value,
        excludeDate: excludeDate,
        disableOutsideEvents: disableOutsideEvents,
        range: range,
        weekendDays: weekendDays
      });
      var onKeyDownPayload = {
        rowIndex: rowIndex,
        cellIndex: cellIndex,
        date: date
      };
      return /* @__PURE__ */React.createElement("td", {
        className: classes.cell,
        key: cellIndex
      }, /* @__PURE__ */React.createElement(Day, {
        ref: function ref(button) {
          if (daysRefs) {
            if (!Array.isArray(daysRefs[rowIndex])) {
              daysRefs[rowIndex] = [];
            }

            daysRefs[rowIndex][cellIndex] = button;
          }
        },
        onClick: function onClick() {
          return typeof onChange === "function" && onChange(date);
        },
        onMouseDown: function onMouseDown(event) {
          return preventFocus && event.preventDefault();
        },
        value: date,
        outside: dayProps.outside,
        weekend: dayProps.weekend,
        inRange: dayProps.inRange || isDateInRange(date, dayProps),
        firstInRange: dayProps.firstInRange || isDateFirstInRange(date, dayProps),
        lastInRange: dayProps.lastInRange || isDateLastInRange(date, dayProps),
        firstInMonth: isSameDate(date, firstDayOfMonth),
        selected: dayProps.selected || dayProps.selectedInRange,
        hasValue: hasValueInMonthRange,
        onKeyDown: function onKeyDown(event) {
          return typeof onDayKeyDown === "function" && onDayKeyDown(onKeyDownPayload, event);
        },
        className: typeof dayClassName === "function" ? dayClassName(date, dayProps) : null,
        style: typeof dayStyle === "function" ? dayStyle(date, dayProps) : null,
        disabled: dayProps.disabled,
        onMouseEnter: typeof onDayMouseEnter === "function" ? onDayMouseEnter : no,
        size: size,
        fullWidth: fullWidth,
        focusable: focusable,
        hideOutsideDates: hideOutsideDates,
        __staticSelector: __staticSelector,
        styles: styles,
        classNames: classNames,
        renderDay: renderDay
      }));
    });
    return /* @__PURE__ */React.createElement("tr", {
      key: rowIndex
    }, cells);
  });
  return /* @__PURE__ */React.createElement(Box, __spreadValues({
    component: "table",
    className: cx(classes.month, className),
    ref: ref
  }, others), !hideWeekdays && /* @__PURE__ */React.createElement("thead", null, /* @__PURE__ */React.createElement("tr", null, weekdays)), /* @__PURE__ */React.createElement("tbody", null, rows));
});
Month.displayName = "@mantine/dates/Month";
export { Month };